import type { HttpCore } from '../http';
import type { Alert, AlertsQuery, Paged } from '../types';

/** `/api/v1/alerts` — open/resolved health alerts for the signed-in customer's devices. */
export function createAlertsApi(http: HttpCore) {
  return {
    list: (query: AlertsQuery = {}) =>
      http.get<Paged<Alert>>('/alerts', {
        query: { status: query.status, deviceId: query.deviceId, page: query.page, pageSize: query.pageSize },
      }),
    open: () => http.get<Paged<Alert>>('/alerts', { query: { status: 'open' } }),
  };
}

export type AlertsApi = ReturnType<typeof createAlertsApi>;
